'use client';

import { useId } from 'react';
import { clsx } from 'clsx';

const StarPaths = () => (
  <>
    <path d="M13 0L16.7289 7.8676L25.3637 8.98278L19.0335 14.9604L20.6412 23.5172L13 19.344L5.35879 23.5172L6.9665 14.9604L0.636266 8.98278L9.27109 7.8676L13 0Z" />
    <path d="M41 0L44.7289 7.8676L53.3637 8.98278L47.0335 14.9604L48.6412 23.5172L41 19.344L33.3588 23.5172L34.9665 14.9604L28.6363 8.98278L37.2711 7.8676L41 0Z" />
    <path d="M69 0L72.7289 7.8676L81.3637 8.98278L75.0335 14.9604L76.6412 23.5172L69 19.344L61.3588 23.5172L62.9665 14.9604L56.6363 8.98278L65.2711 7.8676L69 0Z" />
    <path d="M97 0L100.729 7.8676L109.364 8.98278L103.034 14.9604L104.641 23.5172L97 19.344L89.3588 23.5172L90.9665 14.9604L84.6363 8.98278L93.2711 7.8676L97 0Z" />
    <path d="M125 0L128.729 7.8676L137.364 8.98278L131.034 14.9604L132.641 23.5172L125 19.344L117.359 23.5172L118.966 14.9604L112.636 8.98278L121.271 7.8676L125 0Z" />
  </>
);

type RatingProps = {
  rating: number;
  size?: {
    mobile: number;
    tablet: number;
    desktop: number;
  };
  className?: string;
}

export function Rating({
  rating,
  className,
  size = {
    mobile: 1,
    tablet: 1,
    desktop: 1,
  },
}: RatingProps) {
  const maskId = useId();
  const cssVars = {
    '--r-mob': size.mobile,
    '--r-tab': size.tablet,
    '--r-desk': size.desktop,
  } as React.CSSProperties;

  const sizeClasses = clsx(
    'w-[calc(138px*var(--r-mob))] h-[calc(26px*var(--r-mob))]',
    'md:w-[calc(138px*var(--r-tab))] md:h-[calc(26px*var(--r-tab))]',
    'lg:w-[calc(138px*var(--r-desk))] lg:h-[calc(26px*var(--r-desk))]'
  );

  return (
    <div className={clsx('relative inline-block', sizeClasses, className)} style={cssVars}>
      <svg
        viewBox="0 0 138 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx('absolute top-0 left-0', sizeClasses)}
      >
        <g stroke="currentColor">
          <StarPaths />
        </g>
      </svg>

      <svg
        viewBox="0 0 138 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx('absolute top-0 left-0', sizeClasses)}
      >
        <defs>
          <clipPath id={maskId}>
            <rect x="0" y="0" width={`${rating * 20}%`} height="100%" />
          </clipPath>
        </defs>

        <g fill="currentColor" clipPath={`url(#${maskId})`}>
          <StarPaths />
        </g>
      </svg>
    </div>
  );
}
